import React from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";

import "./style.scss";
import { RegistrationComments } from "components/programCardComponents/RegistrationComments";

export const OpenUntilAndSignUp = ({ labels, semester, item, trackId, parentComponent }) => {
  const handleSignUpButton = () => {
    const inSearchPage = (parentComponent === "SearchResult");
    if (inSearchPage) {
      var url = labels.url_registaration_button + item.field_plain_id_programs.join("_");
      window.open(url, '_blank');
    } else {
        var url = labels.url_registaration_button + trackId;
        window.open(url, '_blank');
      }
    }
  
  const checkIfOpen = () => {
    if (!semester?.field_end_registration) {
      return false;
    }
    let programDate = semester?.field_end_registration; 
    programDate = programDate.split("/");
    let programTimeStamp = new Date( programDate[2], programDate[1]-1 , programDate[0]) 
    const currentDate = new Date();
    const currentTimeTtamp =  new Date(currentDate.getFullYear(),(currentDate.getMonth()),currentDate.getDate(),); 
    if (currentTimeTtamp <= programTimeStamp){
      return true;
    } else {
      return false;
    }
  }

  return(
    <div className="open-until-and-signup">
      <p  
        id="openUntil"
        className={checkIfOpen() ? "open-until-sentence" : "closed-sentence"} 
        aria-labelledby="openUntil"
        tabIndex="0">
          {checkIfOpen() 
            ? `${semester?.title} ${labels?.open_until}` 
            : labels?.registration_closed
          }
      </p>
      <RegistrationComments item={item}/>
      {checkIfOpen() && (
        <Button aria-label={labels?.signup_btn_content} className="signup-btn" onClick={handleSignUpButton}>
          <span>{ labels?.signup_btn_content }</span>
          <div className="register-program-icon" />
        </Button>
      )}
    </div>
  )

}

